export enum ErrorPageType {
    Unknown = 0,
    CardNotOnWhitelist = 10,
    UnknownUserOrPassword = 20,
    NoConnection = 30,
    UnknownUserInDynamics = 40
}